import { DropInPaymentsCommandNames, StatusTypes } from '@chegg/commerce-utils';
import { doFireStatusUpdate } from '../../../../utils/CallbackUtils';

/**
 * Util to fire status update when billdesk response is sent
 * @param status
 * @param txnResponse
 */
export var sendBilldeskResponse = function sendBilldeskResponse(status, txnResponse) {
  doFireStatusUpdate([{
    status: StatusTypes.PENDING,
    command: DropInPaymentsCommandNames.BILLDESK_RESPONSE_HANDLER,
    payload: {
      data: {
        status: status,
        txnResponse: txnResponse
      }
    }
  }]);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/redux/CommandState/commands/helpers/sendBilldeskResponse.js
// module id = 4596
// module chunks = 11